import Addressbar from './AddressBar';
export default Addressbar;
